import { getToken } from "./utils/dataStorage";
import config from "./config/app"

var websock = null;
var timer = null;
var serverData = {};
/**
 * 初始化websocket
 * @returns 
 */
function initWebSocket() {
    console.info('copnfig', config);
    //websocket
    var wsuri = config.socketUrl + "/api/ticketer-server";
    websock = new WebSocket(wsuri);

    websock.onopen = function() {
        websocketOpen();
    }

    websock.onmessage = function(e) {
        let data = JSON.parse(e.data);
        // 预处理保存部分数据
        if (data.type.endsWith("OrderCount")) {
            serverData[data.type] = data.content;
        }
        if (_this) {
            _this.$root.$emit(data.type + 'Event', data);
        }
        console.info(data.type, data);
    }

    websock.onerror = function(e) {
        console.error("TicketerWebSocket error!", e);
    }

    websock.onclose = function(e) {
        websocketclose(e);
    }
}

function websocketclose(e) {
    // 关闭心跳
    if (timer) {
        clearInterval(timer);
        timer = null;
    }
    // 5秒后重新初始化
    setTimeout(() => {
        initWebSocket();
    }, 5000);
}

function websocketOpen(e) {
    console.log("连接成功");
    let token = getToken();
    if (token)
        sendSock({ type: "JD_LOGIN", content: getToken() });
    timer = setInterval(() => {
        sendSock({ type: 'PING' });
    }, 30000)
}

var _this = null;

initWebSocket();
// 初始化
function initSocket(_vue) {
    _this = _vue;
}
// 推送数据
function sendSock(agentData) {
    if (!websock) {
        // 未初始化：超时断连期间
        return setTimeout(function() {
            sendSock(agentData);
        }, 1000);
    }
    if (websock.readyState != websock.OPEN) {
        // 连接未打开：断连期间/连接之前
        return setTimeout(function() {
            sendSock(agentData);
        }, 1000);
    }
    websock.send(JSON.stringify(agentData));
}
// 关闭连接
function socket_close() {
    if (websock) {
        websock.close();
        websock = null
    }
}

function getServerData() {
    return serverData;
}

export { initSocket, sendSock, socket_close, getServerData }